import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import { useIntl } from 'react-intl';

import Message from 'components/Message';
import { ICONS } from 'constants/icons';
import { intlMessage } from 'constants/propTypes';
import { bem } from 'helpers/class-name';

import messages from './SkuErrorBanner.messages';
import './SkuErrorBanner.scss';

const { block, element } = bem('sku-error-banner');

const SkuErrorBanner = ({ title, body, bodyValues, onDismiss }) => {
  const intl = useIntl();

  return (
    <div className={block()} role="alert">
      <Isvg src={ICONS.error} className={element('icon')} />
      <div className={element('text')}>
        <Message as="p" message={title} className={element('title')} />
        <Message as="p" message={body} values={bodyValues} className={element('body')} />
      </div>
      <button
        type="button"
        className={element('dismiss')}
        aria-label={intl.formatMessage(messages.dismissLabel)}
        onClick={onDismiss}>
        <Isvg src={ICONS.cross} className={element('dismiss-icon')} />
      </button>
    </div>
  );
};

SkuErrorBanner.propTypes = {
  title: intlMessage.isRequired,
  body: intlMessage.isRequired,
  bodyValues: PropTypes.shape({}),
  onDismiss: PropTypes.func.isRequired,
};

export default SkuErrorBanner;
